import {
  SimpleAnswerEnum,
  CurrencyEnum,
  MgmtFeeFrequencyEnum,
  PassThroughManagementFeeTypeEnum,
  SimpleAnswerPassEnum,
  ActiveTimePeriodEnum,
} from '../../enums/entity.enum';
import {
  CalendarUnitEnum,
  MgmtFeeRateTypeEnum,
  IncFeeRateTypeEnum,
  HighWaterMarkEnum,
} from '../../enums/openEnd.enum';
import {
  SidePocket,
  Lockup,
  Gate,
  MgmtFeeRate,
  OpenMgmtFeeDiscount,
  IncFeeRate,
  IncentiveFeeDiscount,
} from '../entities/entities.model';
import { StoreModelType } from '@aksia/infrastructure';
import { IOpenShareClass } from '../../interfaces/shareclass/shareclass.open.interface';
import { ShareClass } from './shareclass';

/* export class OpenClassStoreModel extends StoreModel {
  classType?: string = 'OpenShareClass';
} */

export class OpenShareClass extends ShareClass implements IOpenShareClass {
  classType?: string = 'OpenShareClass';

  //#region <<< Section - Side Pockets >>>

  hasSidePocket?: SimpleAnswerEnum = undefined;

  @StoreModelType(() => SidePocket)
  sidePockets?: Array<SidePocket> = undefined;
  sidePocketOpt?: SimpleAnswerEnum = undefined;

  //#endregion

  //#region <<< Section - Subscriptions >>>

  minimumInitialInvestment?: number = undefined;
  minimumAdditionalInvestment?: number = undefined;
  minimumInvestmentCurrency?: CurrencyEnum = undefined;
  hasSubscriptionFee?: SimpleAnswerEnum = undefined;
  subscriptionFee?: number = undefined;

  //#endregion

  //#region <<< Section - Redemptions >>>

  hasLockup?: SimpleAnswerEnum = undefined;
  lockupEndAllow?: boolean = undefined;

  @StoreModelType(() => Lockup)
  lockups?: Array<Lockup> = undefined;
  redemptionTermsFrequencyAmount?: number = undefined;
  redemptionTermsFrequency?: CalendarUnitEnum = undefined;
  redemptionCustomDates?: string = undefined;
  redemptionTermsFrequencyDay?: string = undefined;
  redemptionTermsNotice?: number = undefined;
  redemptionTermsNoticePeriod?: ActiveTimePeriodEnum = undefined;
  redemptionFee?: number = undefined;
  hasGate?: SimpleAnswerEnum = undefined;

  @StoreModelType(() => Gate)
  gates?: Array<Gate> = undefined;
  holdback?: number = undefined;

  //#endregion

  //#region <<< Section - Fees >>>

  hasManagementFee?: SimpleAnswerPassEnum = undefined;
  managementFeePassThrough?: PassThroughManagementFeeTypeEnum = undefined;
  mgmtFeeRateType?: MgmtFeeRateTypeEnum = undefined;

  @StoreModelType(() => MgmtFeeRate)
  mgmtFeeRates?: Array<MgmtFeeRate> = undefined;
  payable?: MgmtFeeFrequencyEnum = undefined;
  payableDescription?: string = undefined;
  hasManagementFeeDiscounts?: SimpleAnswerEnum = undefined;

  @StoreModelType(() => OpenMgmtFeeDiscount)
  managementFeeDiscounts?: Array<OpenMgmtFeeDiscount> = undefined;
  hasIncentiveFee?: SimpleAnswerEnum = undefined;
  incFeeRateType?: IncFeeRateTypeEnum = undefined;

  @StoreModelType(() => IncFeeRate)
  incFeeRates?: Array<IncFeeRate> = undefined;
  crystalization?: number = undefined;
  crystalizationPeriod?: CalendarUnitEnum = undefined;
  highwaterMark?: HighWaterMarkEnum = undefined;
  hasIncentiveFeeDiscounts?: SimpleAnswerEnum = undefined;

  @StoreModelType(() => IncentiveFeeDiscount)
  incentiveFeeDiscounts?: Array<IncentiveFeeDiscount> = undefined;

  //#endregion

  constructor() {
    super();
    this.className = 'Default Class';
  }
}
